import { X, Plus } from 'lucide-react';
import { useState } from 'react';

export default function TagInputField({ label, values, onChange, presets = [], placeholder = 'Type and press Enter' }) {
  const [input, setInput] = useState('');

  const toggle = (val) =>
    onChange(values.includes(val) ? values.filter(v => v !== val) : [...values, val]);

  const addCustom = () => {
    const v = input.trim();
    if (!v || values.includes(v)) { setInput(''); return; }
    onChange([...values, v]);
    setInput('');
  };

  const chip = (active) => ({
    display: 'inline-flex', alignItems: 'center', gap: 5,
    padding: '4px 10px', borderRadius: 20, fontSize: '.72rem',
    cursor: 'pointer', margin: '3px',
    border: `1px solid ${active ? 'var(--gold)' : 'rgba(255,255,255,.14)'}`,
    background: active ? 'rgba(201,168,76,.14)' : 'rgba(255,255,255,.03)',
    color: active ? 'var(--gold)' : 'rgba(255,255,255,.5)',
    fontFamily: 'var(--sans)',
    transition: 'all .18s',
    userSelect: 'none',
  });

  const LBL = {
    fontSize: '.6rem', color: 'rgba(255,255,255,.36)',
    letterSpacing: '.1em', textTransform: 'uppercase',
    marginBottom: 8, display: 'block',
  };

  return (
    <div>
      <label style={LBL}>{label}</label>

      {presets.length > 0 && (
        <div style={{ marginBottom: 8 }}>
          {presets.map(p => (
            <span key={p} style={chip(values.includes(p))} onClick={() => toggle(p)}>
              {p}
              {values.includes(p) && <X size={9} />}
            </span>
          ))}
        </div>
      )}

      <div style={{ display: 'flex', gap: 6 }}>
        <input
          id={`tag-input-${label.toLowerCase().replace(/\s+/g, '-')}`}
          name={`tag-input-${label.toLowerCase().replace(/\s+/g, '-')}`}
          style={{
            flex: 1,
            background: 'rgba(255,255,255,.05)',
            border: '1px solid rgba(201,168,76,.18)',
            borderRadius: 5,
            padding: '8px 11px',
            color: '#fff',
            fontSize: '.82rem',
            fontFamily: 'var(--sans)',
            outline: 'none',
          }}
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder={placeholder}
          onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), addCustom())}
        />
        <button
          onClick={addCustom}
          style={{
            background: 'rgba(201,168,76,.1)',
            border: '1px solid rgba(201,168,76,.25)',
            borderRadius: 5, padding: '8px 12px',
            color: 'var(--gold)', cursor: 'pointer',
          }}
        >
          <Plus size={13} />
        </button>
      </div>

      {values.filter(v => !presets.includes(v)).length > 0 && (
        <div style={{ marginTop: 6 }}>
          {values.filter(v => !presets.includes(v)).map(v => (
            <span key={v} style={chip(true)} onClick={() => toggle(v)}>
              {v} <X size={9} />
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
